import { render, staticRenderFns } from "./DialogFeedback.vue?vue&type=template&id=3ddae97a&scoped=true"
import script from "./DialogFeedback.js?vue&type=script&lang=js&external"
export * from "./DialogFeedback.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ddae97a",
  null
  
)

export default component.exports